import { ref, get } from "firebase/database";
import { database } from "@/common/firebase";
import { createModuleResetter } from "@/helpers/utils";

import { FETCH, GET } from "../../actions";
import { SET_KEY, SET_ITEM, RESET_STORE } from "../../mutations";

const getInitState = () => ({
  resources: {},
  currentResource: null,
});

const getters = {};

const mutations = {
  [SET_KEY](state, { key, value }) {
    state[key] = { ...value };
  },
  [SET_ITEM](state, { id, ...payload }) {
    state.resources[id] = { ...payload };
  },
  [RESET_STORE]: createModuleResetter(getInitState),
};

const actions = {
  async [FETCH]({ commit }, { country }) {
    try {
      const resourcesRef = ref(database, `index/resources/${country}`);
      const resources = await get(resourcesRef).then((snapshot) => snapshot.val());

      if (resources) {
        commit(SET_KEY, { key: "resources", value: resources });
      }

      return { isSuccess: true, resources };
    } catch (error) {
      console.error("Error fetching resources:", error);
      return { isSuccess: false, error };
    }
  },

  async [GET]({ commit }, { country, id }) {
    try {
      const resourceRef = ref(database, `resources/${country}/${id}`);
      const snapshot = await get(resourceRef);

      const currentResource = snapshot.val();
      if (currentResource) {
        commit(SET_KEY, { key: "currentResource", value: currentResource });
      }

      return { isSuccess: true, resource: currentResource };
    } catch (error) {
      console.error("Error getting resource:", error);
      return { isSuccess: false, error };
    }
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  getters,
  mutations,
  actions,
};
